{
  "import": "Импорт",
  "export": "Экспорт",
  "dashboards": {
    "label": "Дашборды",
    "view": "Просмотр",
    "edit": "Управление дашбордами",
    "publish": "Публикация общих дашбордов",
    "export": "Экспорт дашбордов",
    "import": "Импорт дашбордов"
  },
  "cli": {
    "label": "Консоль",
    "connection": "Подключение",
    "logs": "Логи терминала"
  },
  "third_party_service": {
    "label": "Сторонние сервисы",
    "os_dashboards": "Opensearch",
    "flower": "Flower",
    "alertmanager": "AlertManager",
    "rabbitmq": "RabbitMQ",
    "metrics_agent": "Metrics-agent",
    "metrics_storage": "Metrics-storage",
    "metrics_ruler": "Metrics-ruler"
  },
  "srm": {
    "label": "СРМ",
    "view": "Просмотр СРМ",
    "edit": "Наполнение СРМ",
    "tql": {
      "edit": "Редактирование TQL"
    },
    "modelling": {
      "label": "Моделирование СРМ",
      "view": "Просмотр модели СРМ",
      "edit": "Редактирование модели СРМ",
      "mon": {
        "view": "Просмотр модели мониторинга СРМ",
        "edit": "Редактирование модели мониторинга СРМ"
      },
      "enrichmentPlans": {
        "label": "Планы обогащения",
        "view": "Просмотр планов",
        "edit": "Создание, редактирование и удаление планов"
      },
      "enrichmentProcesses": {
        "label": "Процессы обогащения",
        "view": "Просмотр процессов"
      },
      "citSections": {
        "title": "Разделы ТКЕ",
        "cit": "ТКЕ",
        "attributes": "Атрибуты",
        "links": "Доступные связи",
        "createCI": "Список КЕ",
        "naming": "Именование",
        "identification": "Идентификация",
        "deletePolicy": "Хранение"
      }
    },
    "enrichment": {
      "label": "Планы обогащения",
      "export": "Экспорт планов",
      "import": "Импорт планов"
    },
    "ci": {
      "label": "КЕ",
      "export": "Экспорт КЕ",
      "import": "Импорт КЕ"
    },
    "cit": {
      "label": "ТКЕ",
      "export": "Экспорт ТКЕ",
      "import": "Импорт ТКЕ"
    },
    "external": {
      "routes": {
        "get": "СРМ API"
      }
    }
  },
  "monitoring": {
    "label": "Мониторинг",
    "vmagents": {
      "label": "Агенты сбора метрик"
    },
    "vmalerts": {
      "label": "Агенты обработки правил"
    },
    "hi": {
      "label": "Индикаторы здоровья",
      "edit": "Управление реестром индикаторов",
      "export": "Экспорт индикаторов здоровья",
      "import": "Импорт индикаторов здоровья"
    },
    "templates": {
      "label": "Шаблоны мониторинга",
      "edit": "Управление шаблонами мониторинга",
      "export": "Экспорт шаблонов",
      "import": "Импорт шаблонов"
    },
    "prometheus": {
      "label": "Prometheus",
      "exporters": {
        "label": "Экспортеры",
        "edit": "Настройка экспортеров Prometheus",
        "export": "Экспорт экспортеров",
        "import": "Импорт экспортеров"
      },
      "jobs": {
        "label": "Задания",
        "edit": "Настройка задач Prometheus",
        "export": "Экспорт задач",
        "import": "Импорт задач"
      },
      "edit": "Управление Prometheus"
    }
  },
  "users": {
    "label": "Пользователи",
    "edit": "Управление пользователями",
    "change_password": {
      "edit": "Смена пароля локальных пользователей"
    },
    "status": {
      "edit": "Снятие и установка блокировки пользователя"
    },
    "attribute": {
      "edit": "Редактирование атрибутов пользователя"
    },
    "profile": {
      "view": "Просмотр пользователей",
      "edit": "Создание и редактирование пользователей"
    },
    "ldap": {
      "edit": "Настройка LDAP"
    },
    "oidc": {
      "edit": "Настройка OIDC"
    },
    "delete": {
      "edit": "Удаление пользователей"
    },
    "api_token": {
      "edit": "Управление API токенами"
    },
    "activity": {
      "log": "Журналы аудита"
    },
    "session": {
      "kill": "Принудительное завершение сессии пользователя"
    }
  },
  "access": {
    "label": "Управление доступом",
    "srm": {
      "edit": "СРМ"
    },
    "monitoring": {
      "edit": "Индикаторы здоровья"
    },
    "dashboards": {
      "edit": "Дэшборды"
    },
    "func": {
      "edit": "Функции системы"
    },
    "tql": {
      "edit": "TQL"
    }
  },
  "notifications": {
    "label": "Уведомления",
    "self": {
      "edit": "Личные уведомления"
    },
    "external": {
      "edit": "Внешние сервисы"
    },
    "template": {
      "edit": "Шаблоны сообщений"
    },
    "alertmanager": {
      "edit": "Управление менеджером уведомлений"
    }
  },
  "settings": {
    "edit": "Глобальные настройки"
  },
  "accessDialog": {
    "title": "Внимание!",
    "accessChanged": "Ваши права доступа были изменены!",
    "accept": "Принять"
  },
  "noAccessPage": {
    "no-access-rules": "Ваши настройки доступа не позволяют продолжить работу с приложением",
    "change-user": "Сменить пользователя"
  },
  "system": {
    "docker": {
      "label": "Компоненты",
      "edit": "Редактирование",
      "view": "Просмотр",
      "run": "Управление"
    },
    "content-pack": {
      "label": "Пакет конфигураций",
      "create": "Создание",
      "import": "Импорт"
    },
    "plugins": {
      "edit": "Управление плагинами"
    },
    "debug": {
      "edit": "Отладка системы"
    },
    "label": "Системные настройки",
    "settings": {
      "label": "Глобальные настройки",
      "auth": {
        "label": "Cервис авторизации",
        "view": "Просмотр",
        "edit": "Редактирование"
      },
      "srm": {
        "label": "Cервис SRM",
        "view": "Просмотр",
        "edit": "Редактирование"
      },
      "monitoring": {
        "label": "Cервис мониторинга",
        "view": "Просмотр",
        "edit": "Редактирование"
      },
      "notification": {
        "label": "Cервис уведомлений",
        "view": "Просмотр",
        "edit": "Редактирование"
      },
      "docker_tool": {
        "label": "Docker Tool",
        "view": "Просмотр",
        "edit": "Редактирование"
      },
      "task_tool": {
        "label": "Task Tool",
        "view": "Просмотр",
        "edit": "Редактирование"
      }
    }
  },
  "license": {
    "edit": "Лицензия"
  }
}
